export class Cookies {
    public static get(name: string): string|null {
        const value = `${document.cookie}`;
        const parts = RegExp(`${name}\=([^;]*)`).exec(value);
        return parts && parts.length === 2 ? parts[1] : null;
    }
}